import api from '@/utils/api/index'
import * as types from '~/store/mutation-types'

export const state = () => ({ ceos: {} })

export const getters = { ceos: state => state.ceos }

export const actions = {
  async requestCeos({ commit }) {
    const { data } = await this.$axios.get(api.ceos.getCeos())

    commit(types.SET_CEOS, data)

    return data
  },

  async requestVote(_, { payload }) {
    await this.$axios.post(api.ceos.vote(), payload)
  }
}

export const mutations = {
  [types.SET_CEOS](state, ceos) {
    state.ceos = ceos
  }
}
